import SubjectFilterView from '@UI/Pages/Subjects/SubjectList/Filters/SubjectFilterView';
import { createSignal } from '@verclam/pulsar';

/** No dossier type has this identifier: the list replaces it by the type of the route before fetching. */
const NO_TYPE_ID = 0;

const subjectFiltersSignal = createSignal<SubjectFilterView>(SubjectFilterView.createDefault(NO_TYPE_ID));

export const setSubjectFilters = (filters: SubjectFilterView): void => {
	subjectFiltersSignal.value = filters;
};

export default subjectFiltersSignal;
